'use client'

import { useEffect, useMemo } from 'react'
import {
  initBugsnagClient,
  getBugsnagErrorBoundary,
  setBugsnagUser,
  clearBugsnagUser,
} from '@/lib/bugsnag/client'
import { createBrowserSupabaseClient } from '@/lib/supabase/browser'

initBugsnagClient()

export function BugsnagProvider({ children }: { children: React.ReactNode }) {
  const ErrorBoundary = useMemo(() => getBugsnagErrorBoundary(), [])

  useEffect(() => {
    const supabase = createBrowserSupabaseClient()

    supabase.auth.getUser().then(({ data: { user } }) => {
      if (user) setBugsnagUser({ id: user.id, email: user.email })
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      const u = session?.user
      if (u) setBugsnagUser({ id: u.id, email: u.email })
      else clearBugsnagUser()
    })

    return () => subscription.unsubscribe()
  }, [])

  if (!ErrorBoundary) return <>{children}</>
  return <ErrorBoundary>{children}</ErrorBoundary>
}
